// src/app/features/error/not-found/not-found.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-not-found',
  template: `
   <!-- src/app/features/auth/login/login-successfully.component.html -->

<div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light" style="margin-top: -50%">
  <div class="col-md-8 col-lg-6">
    <!-- Logo Section -->
    <div class="text-center mb-4">
      <img 
        src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4" 
        alt="Sigvaris Group Logo" 
        class="img-fluid mb-3" 
        style="max-width: 200px; height: 120px;">
    </div>
    
    <!-- Success or Error Card -->
    <div class="card custom-card">
      <div class="card-body" style="padding-left: 25px; padding-right: 25px;">
        <!-- Loading State -->
    
          <h2 class="card-title text-center mb-4">The page doesn't exist!</h2>
          
          <!-- Loading Indicator -->
          <div class="text-center mb-4">
            <p class="lead">Redirection to the home page</p>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
  
      </div>
    </div>
    
  </div>
</div>

  `,
  styles: [`
    .not-found {
      text-align: center;
      margin-top: 50px;
    }
  `]
})
export class NotFoundComponent implements OnInit { 

    constructor(private router: Router,  ){
   
      
    }
  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/en-us/order-creation']);
    }, 3000); 
  }

}
